<template>
    <div>
        <form-wrapper
            :redirection="'third.overview.informations'"
            :store="store"
            :current="current"
            :linkedForm="linkedForm"
            @catch-errors="catchErrors"
            :labelSaveAndAction="
                $t.__('pages.forms.ThirdIndividualsForm.save_and_create_individual')
            "
        >
            <template slot="title">{{ this.$l10n.__('Ajouter un nouveau particulier') }}</template>

            <!-- DETAILS -->
            <form-fields-wrapper
                :field="'individual'"
                :toggleAllowed="false"
                :title="$t.__('pages.forms.ThirdIndividualsForm.individual')"
            >
                <form-fields-individuals-details
                    @change-type="changeType"
                    ref="main"
                    :store-module="current"
                    :error="error.errors"
                />
            </form-fields-wrapper>

            <!-- ADDRESS(ES) -->
            <form-fields-wrapper
                :field="'address'"
                :toggleAllowed="true"
                :activeFields="['address']"
                :title="$t.__('pages.forms.ThirdIndividualsForm.address')"
            >
                <form-fields-address
                    v-for="(address, index) in addresses"
                    :key="index"
                    :index="formatIndex(index)"
                    :currentStore="current"
                />
                <CompassButton
                    :label="$t.__('common.actions.add_address')"
                    type="secondary"
                    @click="createNewAddress()"
                    class="wp-10"
                    v-if="addressesFieldsStatus === 'saved'"
                />
            </form-fields-wrapper>

            <!-- ACCOUNTABILITY -->
            <form-fields-wrapper
                :field="'accounting'"
                :active-fields="['accounting']"
                :toggleAllowed="true"
                :title="$t.__('common.labels.accounting')"
                v-if="clientOrSupplier"
            >
                <form-fields-individuals-accountability
                    :store-module="current"
                    :error="error.errors"
                />
            </form-fields-wrapper>

            <!-- CUSTOM FIELDS -->
            <form-fields-wrapper
                field="custom-fields"
                :toggleAllowed="false"
                :active-fields="['custom-fields']"
                :title="$t.__('pages.forms.ThirdIndividualsForm.individual_custom_fields')"
            >
                <form-fields-custom-fields
                    ref="custom-fields"
                    :currentStore="current"
                    :error="error.errors"
                ></form-fields-custom-fields>
            </form-fields-wrapper>
        </form-wrapper>
    </div>
</template>

<script>
// Components
import FormWrapper from 'vcomponents/forms/FormWrapper.vue';
import FormFieldsWrapper from 'vcomponents/forms/FormFieldsWrapper.vue';
import FormFieldsIndividualsDetails from 'vcomponents/thirds/thirdscomponents/FormFieldsIndividualsDetails.vue';
import FormFieldsAddress from 'vcomponents/thirds/thirdscomponents/FormFieldsAddress.vue';
import FormFieldsIndividualsAccountability from 'vcomponents/thirds/thirdscomponents/FormFieldsIndividualsAccountability.vue';
import FormFieldsCustomFields from 'vcomponents/thirds/thirdscomponents/FormFieldsCustomFields.vue';
// Store
import individualModule from 'stores/forms/individual';

export default {
    name: 'ThirdIndividualForm',
    props: {
        linkedForm: {
            type: Object,
            required: false,
            default: null,
        },
    },
    components: {
        FormWrapper,
        FormFieldsWrapper,
        FormFieldsIndividualsDetails,
        FormFieldsAddress,
        FormFieldsIndividualsAccountability,
        FormFieldsCustomFields,
    },
    data() {
        return {
            store: individualModule,
            current: 'individualForm',
            error: {},
        };
    },
    computed: {
        clientOrSupplier() {
            return (
                this.$store.state[this.current].details.type === 'client' ||
                this.$store.state[this.current].details.type === 'supplier'
            );
        },
        addresses() {
            return this.$store.getters[`${this.current}/getAddresses`];
        },
        addressesFieldsStatus() {
            return this.$store.getters[`${this.current}/getAddressesFieldsStatus`];
        },
    },
    methods: {
        changeType(type) {
            this.$store.dispatch(`${this.current}/fetchCustomFieldsByType`, type);
        },
        catchErrors(err) {
            this.error = err ? err : [{}];
        },
        formatIndex(index) {
            return parseInt(index);
        },
        createNewAddress() {
            this.$store.dispatch(`${this.current}/createNewAddress`);
            this.$store.commit(`${this.current}/setAddressesFieldsStatus`, 'pending');
        },
    },
    created() {
        if (!this.$store.state[this.current]) {
            this.$store.registerModule(this.current, individualModule);
        }
    },
    beforeDestroy() {
        this.$store.unregisterModule(this.current);
    },
};
</script>
